var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  x: 0.5,
  y: 0.5,
  stroke: "#fff",
  rx: 7.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 14.4,
  height: 14.4,
  x: 0.801,
  y: 0.801,
  fill: "#008060",
  rx: 7.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.652 11.088 4.106 8.354a.405.405 0 0 1 0-.547l.515-.546a.35.35 0 0 1 .513 0L6.91 9.175l3.954-4.261a.35.35 0 0 1 .515 0l.514.547a.403.403 0 0 1 0 .546l-4.728 5.08a.35.35 0 0 1-.514 0"
})));
export default SvgCheck;